import { Controller } from "@hotwired/stimulus"

// Disables submit until form is valid and at least one prestacion is selected.
export default class extends Controller {
  static targets = ["submit"]

  connect() {
    this.form = this.element.querySelector("form")
    this.validate = this.validate.bind(this)

    this.element.addEventListener("input", this.validate)
    this.element.addEventListener("change", this.validate)

    this.observer = new MutationObserver(() => this.validate())
    this.observer.observe(this.element, { childList: true, subtree: true })

    this.validate()
  }

  disconnect() {
    this.element.removeEventListener("input", this.validate)
    this.element.removeEventListener("change", this.validate)

    if (this.observer) {
      this.observer.disconnect()
    }
  }

  validate() {
    if (!this.hasSubmitTarget || !this.form) return

    const formValid = this.form.checkValidity()
    const hasPracticeSelector = this.element.querySelector('[data-controller~="descripcion-imagen"]') !== null
    const hasPrestaciones = !hasPracticeSelector || this.selectedPrestacionesCount() > 0

    this.submitTarget.disabled = !(formValid && hasPrestaciones)
  }

  selectedPrestacionesCount() {
    return this.element.querySelectorAll('input[name^="pedido_de_imagen[pedido_de_imagen_descripciones_attributes]"][name$="[descripcion_imagen_id]"]').length
  }
}
